/* eslint-disable
    consistent-return
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import * as selectioncontextmenu from 'components/SelectionContextMenu';
import {MAX_VISIBLE_RING_FEATURES} from 'constants/MapsConstants';
import {getArcForStrand} from 'molbio/maps/circular/CircularUtil';
import LabeledSegmentsRingView from 'molbio/maps/circular/LabeledSegmentsRingView';

class CircularAnnotationsView extends LabeledSegmentsRingView {
  static initClass() {
    this.prototype.className = 'annotations';
    this.prototype.singularClassName = 'annotation';
    this.prototype.tagName = 'g';
  }

  contextMenuData() {
    return selectioncontextmenu.ANNOTATION_MENU;
  }
  contextMenuOptions(d) {
    return {annotation: d};
  }
  arc(d) {
    return getArcForStrand(d.strand());
  }

  data() {
    const sequence = this.model.get('sequence');
    // NOTE: For smart rendering, this works, but it look silly.
    let visible = [];
    const total = sequence.annotations();
    const shown = total.slice(this.model.get('leftBP'), this.model.get('rightBP'), (data) => {
      visible = data;
      return _.sortBy(data, (a) => -a.length(sequence)).slice(0, MAX_VISIBLE_RING_FEATURES);
    });

    this.model.set({totalA: total.length, visibleA: visible.length, shownA: shown.length});
    return shown;
  }

  hideHandler() {
    if (!this.layout.get('visible')) {
      return this.model.set({visibleA: 0, shownA: 0});
    }
  }

  clickAction(e, d) {
    return d.click(this.model.get('sequence'), e.shiftKey);
  }

  dblClickAction(e, d) {
    return d.dblClick(this.model.get('sequence'), e.shiftKey);
  }

  registerListeners() {
    super.registerListeners();
    const annotations = this.model.get('sequence').annotations();
    this.listenTo(annotations, 'layerChange', function () {
      this.invalidateData();
      return this.triggerRedraw();
    });
    return this.listenTo(annotations, 'change:hover change:selected', this.handleHover);
  }

  setConstraints(outerRadius) {
    return this.setOuterRadius(outerRadius);
  }

  redrawPlasmid() {
    return true;
  }

  storeBounds(rings) {
    if (rings == null) {
      ({rings} = this);
    }
    this.rings = rings;
    const innerRadius = this.getOuterRadius() - this.layout.get('ringHeight') * this.rings;
    this.layout.set('innerRadius', innerRadius);
    return this.updateRadius();
  }

  zeroBounds() {
    this.layout.set('innerRadius', this.layout.get('outerRadius'));
    return this.updateRadius();
  }

  layerBounds(layer) {
    return {
      innerRadius: this.radiusIn(layer + 1),
      outerRadius: this.radiusIn(layer) - this.layout.vMargin(),
    };
  }

  baseLine(layer, innerRadius = null) {
    return this.radiusIn(layer + 1);
  }
}
CircularAnnotationsView.initClass();

export default CircularAnnotationsView;
